import { isEmpty } from '@backmarket/utils/object/isEmpty'

import type { ApplePayJS } from '../../../../../types/apple-pay'
import type { PaymentRequestPaymentResponseResult } from '../../../types/PaymentRequest'

import { mapAddressErrorsToApplePayErrors } from './mapAddressErrorsToApplePayErrors'

export const mapPaymentResponseResultToApplePayErrors = (
  result: PaymentRequestPaymentResponseResult,
): ApplePayJS.ApplePayError[] | undefined => {
  if (isEmpty(result.errors)) {
    return undefined
  }

  const errors = mapAddressErrorsToApplePayErrors(result.errors)

  return errors.length > 0 ? errors : undefined
}
